import { tileChapterOfLevel } from "./chapters.ts";
import { TILE_CONTENT_VERSION, TILE_PACK_LOADERS } from "./packs.generated.ts";
import { tilePackSchema, type TileLevel, type TilePack } from "./schema.ts";

const packCache = new Map<number, Promise<TilePack>>();

/** Loads (once) and validates one Lối Ngọc chapter pack; nothing of the house downloads before. */
export function loadTileChapter(chapter: number): Promise<TilePack> {
  let pending = packCache.get(chapter);
  if (!pending) {
    const loader = TILE_PACK_LOADERS[chapter];
    if (!loader) return Promise.reject(new Error(`no tile pack for chapter ${chapter}`));
    pending = loader().then((raw) => {
      const pack = tilePackSchema.parse(raw);
      if (pack.contentVersion !== TILE_CONTENT_VERSION) throw new Error(`pack ${chapter} has version ${pack.contentVersion}`);
      return pack;
    });
    pending.catch(() => packCache.delete(chapter));
    packCache.set(chapter, pending);
  }
  return pending;
}

export async function loadTileLevel(levelId: number): Promise<TileLevel> {
  const pack = await loadTileChapter(tileChapterOfLevel(levelId).chapter);
  const level = pack.levels.find((candidate) => candidate.id === levelId);
  if (!level) throw new Error(`tile level ${levelId} missing from pack`);
  return level;
}
